// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2GvI2","choiceBoxes":"toolbarselects_choiceBoxes__3FAGO","simpleField":"toolbarselects_simpleField__Nw1NH"};